import attachments from "./attachments";
import crmCampaigns from "./crm-campaigns";
import crmLeads from "./crm-leads";
import crmSchedules from "./crm-schedules";
import crmSenders from "./crm-senders";
import crmSequences from "./crm-sequences";
import crmTemplates from "./crm-templates";
import auth from "./auth";
import brands from "./brands";
import brokers from "./brokers";
import call from "./call";
import campaigns from "./campaigns";
import campaignStates from "./campaignStates";
import categoryWeight from "./category-weight";
import commissionStatements from "./commission-statements";
import commissions from "./commissions";
import contacts from "./contacts";
import contracts from "./contracts";
import coverageBenefits from "./coverage-benefits";
import coverageCategories from "./coverage-categories";
import coverages from "./coverages";
import dashboard from "./dashboard";
import distributions from "./distributions";
import events from "./events";
import flows from "./flows";
import geoZones from "./geo-zones";
import generalCosts from "./general-cost";
import insurancePlanCoverages from "./insurance-plan-coverage";
import insurancePlans from "./insurance-plans";
import links from "./link";
import notes from "./notes";
import notifications from "./notifications";
import offers from "./offers";
import organizations from "./organizations";
import poles from "./poles";
import pricers from "./pricers";
import processStatuses from "./process-statuses";
import processes from "./processes";
import projects from "./projects";
import qualifications from "./qualifications";
import qualifiers from "./qualifiers";
import quotes from "./quotes";
import referentials from "./referentials";
import reminders from "./reminders";
import sources from "./sources";
import stores from "./stores";
import subscriptions from "./subscription";
import tasks from "./tasks";
import templates from "./templates";
import tracers from "./tracers";
import userActivity from "./user-activity";
import users from "./users";
import webhooks from "./webhooks";
import workflows from "./workflows";

const queries = {
  ...attachments,
  ...contacts,
  ...contracts,
  ...organizations,
  ...projects,
  ...auth,
  ...users,
  ...sources,
  ...tracers,
  ...flows,
  ...processes,
  ...insurancePlans,
  ...coverages,
  ...coverageBenefits,
  ...processStatuses,
  ...qualifiers,
  ...qualifications,
  ...webhooks,
  ...notes,
  ...reminders,
  ...quotes,
  ...generalCosts,
  ...subscriptions,
  ...commissions,
  ...brokers,
  ...call,
  ...workflows,
  ...pricers,
  ...commissionStatements,
  ...distributions,
  ...referentials,
  ...categoryWeight,
  ...coverageCategories,
  ...insurancePlanCoverages,
  ...offers,
  ...dashboard,
  ...links,
  ...userActivity,
  ...brands,
  ...templates,
  ...stores,
  ...notifications,
  ...events,
  ...poles,
  ...campaigns,
  ...tasks,
  ...campaignStates,
  ...geoZones,
  ...crmCampaigns,
  ...crmSequences,
  ...crmSenders,
  ...crmSchedules,
  ...crmTemplates,
  ...crmLeads,
};

export default queries;
